import { OrderStatus } from '../shared/enums';

export enum SocketEventType {
  ChequeUpdated = 'cheque.updated',
  ChequePayment = 'cheque.payment',
  ChequeClosed = 'cheque.closed',
  OrderStatus = 'order.status',
  PaymentConfirmed = 'payment.confirmed',
  MenuUpdated = 'menu.updated'
}

// cheque.updated/cheque.payment/cheque.closed share this shape — all three just mean "reload this cheque".
export interface ChequeEvent {
  type: SocketEventType.ChequeUpdated | SocketEventType.ChequePayment | SocketEventType.ChequeClosed;
  table_id: string;
  cheque_id: string;
}

export function isChequeEvent(event: { type: SocketEventType }): event is ChequeEvent {
  return event.type === SocketEventType.ChequeUpdated
    || event.type === SocketEventType.ChequePayment
    || event.type === SocketEventType.ChequeClosed;
}

export interface OrderStatusEvent {
  type: SocketEventType.OrderStatus;
  table_id: string;
  order_id: string;
  user_id: string;
  status: OrderStatus;
}

export interface PaymentConfirmedEvent {
  type: SocketEventType.PaymentConfirmed;
  user_id: string;
  data: unknown;
}

export interface MenuUpdatedEvent {
  type: SocketEventType.MenuUpdated;
  zone_id: string;
}

export type TableSocketEvent =
  | ChequeEvent
  | OrderStatusEvent
  | PaymentConfirmedEvent
  | MenuUpdatedEvent;
